import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Observable, tap } from "rxjs";
import { environment } from "../../environments/environment";
import { EtagEntitiesEnum } from "../models/shared.model";
import { SharedService } from "../services/shared.service";

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  constructor(
    private sharedService: SharedService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {

          const etagHeader = event.headers.get('Etag');

          if(etagHeader)
            this.cacheEtagValue(etagHeader, req.url)
        }
      })
    );
  }

  private cacheEtagValue(etagValue: string, url: string){
    let etagEntity: EtagEntitiesEnum;

    if (url.startsWith(environment.backendUrl) && url.includes("settings"))
      etagEntity = EtagEntitiesEnum.SETTINGS

    if(url.startsWith(environment.backendUrl) && url.includes("batch/all"))
      etagEntity = EtagEntitiesEnum.BATCH_ALL

    if(url.startsWith(environment.backendUrl) && url.includes("user/me"))
      etagEntity = EtagEntitiesEnum.PROFILE

    if(url.startsWith(environment.backendUrl) && url.includes("terms-and-conditions"))
      etagEntity = EtagEntitiesEnum.TERMS_AND_CONDITION

    this.sharedService.setEtag(etagEntity, etagValue);
  }
}
